var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',_vm._b({staticClass:"blw-control blw-checkbox",on:{"change":function($event){return _vm.$emit('input', $event)}}},'v-checkbox',{ ..._vm.$props, ..._vm.$attrs },false))
}
var staticRenderFns = []

export { render, staticRenderFns }